import Vue from 'vue'

const BaseMethodsFunctions = require('./BaseMethodsFunctions')

Vue.mixin(BaseMethodsFunctions.default)